module.exports = __webpack_public_path__ + "img/case-code.8feb9a9.png";